import React, { useState, useEffect } from 'react';
import './OrderHistory.css';
import OrderDetails from './OrderDetails';
import { FaShoppingBag, FaBoxOpen } from 'react-icons/fa';
import { API, authHeadersOnly } from '../services/apiConfig';

const STATUS_COLORS = {
  PENDING:    '#f59e0b',
  PROCESSING: '#3b82f6',
  SHIPPED:    '#8b5cf6',
  DELIVERED:  '#22c55e',
  CANCELLED:  '#ef4444',
};

function OrderHistory({ userId, onClose }) {
  const [orders, setOrders]           = useState([]);
  const [loading, setLoading]         = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    if (!userId) { setLoading(false); return; }
    fetch(`${API}/api/orders/user/${userId}`, { headers: authHeadersOnly() })
      .then(r => r.ok ? r.json() : [])
      .then(data => setOrders(Array.isArray(data) ? data : []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [userId]);

  if (!userId) return null;

  const resolveImg = (url) => {
    if (!url) return '/images/product.jpg';
    if (url.startsWith('http')) return url;
    return `${API}${url}`;
  };

  const parseItems = (raw) => {
    try { return JSON.parse(raw); } catch { return []; }
  };

  return (
    <div className="order-history-overlay" onClick={selectedOrder ? undefined : onClose}>
      <div className="order-history-modal" onClick={e => e.stopPropagation()}>

        <div className="order-history-header">
          <div>
            <h2><FaShoppingBag style={{ marginRight: '10px', verticalAlign: 'middle' }} />My Orders</h2>
            <span>{orders.length} order{orders.length !== 1 ? 's' : ''} placed</span>
          </div>
          <button className="order-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="order-history-body">
          {selectedOrder ? (
            <OrderDetails order={selectedOrder} user={{ userId }} onBack={() => setSelectedOrder(null)} />
          ) : loading ? (
            <div className="order-history-loading"><div className="spinner" /></div>
          ) : orders.length === 0 ? (
            <div className="order-history-empty">
              <div className="empty-icon"><FaBoxOpen /></div>
              <h3>No Orders Yet</h3>
              <p>Start shopping to see your order history here</p>
            </div>
          ) : (
            <div className="orders-list">
              {orders.map(order => {
                const items = parseItems(order.items);
                return (
                  <div key={order.id} className="order-card">

                    <div className="order-card-header">
                      <div className="order-id-block">
                        <div className="order-id-label">Order ID</div>
                        <div className="order-id-value">#{order.id}</div>
                      </div>
                      <div className="order-meta">
                        <div className="order-date">
                          {new Date(order.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                        </div>
                        <span className="status-badge" style={{ background: STATUS_COLORS[order.status] || '#999' }}>
                          {order.status}
                        </span>
                      </div>
                    </div>

                    <div className="order-card-body">
                      <div>
                        <div className="order-amount">₹{order.totalAmount?.toFixed(2)}</div>
                        {order.shippingAddress && (
                          <div className="order-address">
                            <i class="fa-solid fa-location-dot"></i>
                            <span>{order.shippingAddress}</span>
                          </div>
                        )}
                      </div>
                    </div>

                    {items.length > 0 && (
                      <div className="order-items">
                        <div className="items-preview-list">
                          {items.map((item, i) => (
                            <div key={i} className="item-preview-card">
                              <img
                                src={resolveImg(item.image)}
                                alt={item.productName}
                                className="item-thumb"
                                onError={e => { e.target.src = '/images/product.jpg'; }}
                              />
                              <div className="item-info">
                                <p className="item-name">{item.productName}</p>
                                <p className="item-details">Qty: {item.quantity} × ₹{item.price}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="order-card-footer">
                      <button className="view-details-btn" onClick={() => setSelectedOrder(order)}>
                        View Order Details 
                      </button>
                    </div>

                  </div>
                );
              })}
            </div>
          )}
        </div>

      </div>
    </div>
  );
}

export default OrderHistory;
